import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import withRestrictedAccess from '../../higherOrderComponents/withRestrictedAccess';
import TestingPermissions from '../../components/Resources/integrationNew/Integration/Permissions/Testing';

const IntegrationPermissionsTesting = () => <TestingPermissions />;

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state),
  withRestrictedAccess
);

export default enhance(IntegrationPermissionsTesting);
